import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48f0daa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "step__basic"
}
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { for: "title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Нажмите чтобы загрузить готовое приложение", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите количество эскизов", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выберите из списка", -1))
const _hoisted_11 = {
  key: 0,
  class: "uploadfile_photo"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Добавьте изображение эскизного проекта")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "blueSpan"
}
const _hoisted_14 = {
  key: 1,
  class: "blueSpan"
}
const _hoisted_15 = {
  key: 2,
  class: "blueSpan"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда файл "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" или нажмите для загрузки")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Перенесите сюда файл "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" или нажмите для загрузки")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "filenameSpan" }
const _hoisted_21 = {
  key: 5,
  class: "dots-container"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"dot\" data-v-48f0daa0></div><div class=\"dot\" data-v-48f0daa0></div><div class=\"dot\" data-v-48f0daa0></div><div class=\"dot\" data-v-48f0daa0></div><div class=\"dot\" data-v-48f0daa0></div>", 5)
const _hoisted_27 = [
  _hoisted_22
]
const _hoisted_28 = {
  key: 0,
  class: "right",
  style: {"position":"absolute","margin-left":"505px","top":"175px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Пример изображения", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/spb/eskiz1.jpg" }, null, -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "right",
  style: {"position":"absolute","margin-left":"505px","top":"231px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Пример изображения", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/spb/eskiz1.jpg" }, null, -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Trash = _resolveComponent("Trash")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass({activeStep: _ctx.subpage == 1}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subpage = 1)),
        style: {"width":"104px"}
      }, "Шаг 1", 2)),
      (_ctx.document.app4_file_checked == 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Number(_ctx.document.sketch_count), (n) => {
            return (_openBlock(), _createElementBlock("button", {
              key: Number(n+1),
              class: _normalizeClass({activeStep: _ctx.subpage == n+1}),
              onClick: ($event: any) => {_ctx.prepareFileUpload_click(Number(n+1));},
              style: {"width":"104px"}
            }, "Шаг " + _toDisplayString(Number(n+1)), 11, _hoisted_2))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    (_ctx.subpage == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("section", null, [
              _createElementVNode("label", _hoisted_5, [
                _createVNode(_component_v_switch, {
                  style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
                  color: "#2F80ED",
                  modelValue: _ctx.document.app4_file_checked,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.app4_file_checked) = $event)),
                  label: "Использовать готовое приложение №4",
                  inline: ""
                }, null, 8, ["modelValue"]),
                (_ctx.document.app4_file_checked == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("input", {
                        ref: "app4_file",
                        type: "file",
                        accept: ".pdf",
                        hidden: "",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFile('app4_file')))
                      }, null, 544),
                      _hoisted_7,
                      _createElementVNode("button", {
                        class: "btn_upload",
                        style: {"width":"480px"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.app4_file.click()))
                      }, "Загрузить файл приложения №4 на сервер"),
                      _createElementVNode("span", {
                        style: {"cursor":"pointer"},
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=app4_file', _ctx.document.app4_file.split('/')[_ctx.document.app4_file.split('/').length-1]);})
                      }, "Файл приложения №4 - " + _toDisplayString(_ctx.document.app4_file.split('/')[_ctx.document.app4_file.split('/').length-1] == "" ? 'не загружен' : _ctx.document.app4_file.split('/')[_ctx.document.app4_file.split('/').length-1]), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.document.app4_file_checked == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.sketch_title,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sketch_title) = $event)),
                    editable: "",
                    options: _ctx.sketch_options,
                    optionLabel: "name",
                    placeholder: _ctx.sketch_default.name,
                    style: {"width":"480px"},
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sketch_change($event)))
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref: "sketch_multiple_file",
      type: "file",
      hidden: "",
      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitFile('sketch_multiple_file', _ctx.subpage-2, _ctx.document.sketch_arr[_ctx.subpage-2]['name'])))
    }, null, 544),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(_ctx.document.sketch_count)+1, (n) => {
      return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.subpage == n+1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "left",
                style: _normalizeStyle(_ctx.subpage-2 == 0 ? 'margin-top: 0px;' : 'margin-top: 0px;')
              }, [
                _hoisted_12,
                (_ctx.subpage == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Добавьте фото в поле ниже. Рекомедуемый размер: 604px x 667px"))
                  : _createCommentVNode("", true),
                (_ctx.subpage > 2 && _ctx.document.sketch_arr[_ctx.subpage-2]['name'] == false)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Добавьте фото в поле ниже. Рекомедуемый размер: 604px x <=1030px"))
                  : _createCommentVNode("", true),
                (_ctx.subpage > 2 && _ctx.document.sketch_arr[_ctx.subpage-2]['name'] == true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Добавьте фото в поле ниже. Рекомедуемый размер: 1050px x 721px"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (_ctx.subpage-2 != 0)
                    ? (_openBlock(), _createBlock(_component_v_switch, {
                        key: 0,
                        style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
                        color: "#2F80ED",
                        modelValue: _ctx.document.sketch_arr[_ctx.subpage-2]['name'],
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.document.sketch_arr[_ctx.subpage-2]['name']) = $event)),
                        label: "Горизонтальный файл эскизного проекта",
                        inline: "",
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.noSubmitFile('sketch_multiple_file', _ctx.subpage-2, _ctx.document.sketch_arr[_ctx.subpage-2]['name'])))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.document.sketch_arr[_ctx.subpage-2]['file'] != '')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "fileUpload",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$refs.sketch_multiple_file.click())),
                      ref_for: true,
                      ref: "fileformuploaded",
                      style: _normalizeStyle('background: url(\'https://api.rekprof.ru/files/'+_ctx.document.sketch_arr[_ctx.subpage-2]['file']+'?a='+_ctx.unicFile+'\'); background-position: center; background-size: contain; background-repeat: no-repeat; border: 1px solid black;')
                    }, _hoisted_17, 4))
                  : _createCommentVNode("", true),
                (_ctx.document.sketch_arr[_ctx.subpage-2]['file'] == '')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      ref_for: true,
                      ref: "fileform",
                      class: "fileUpload",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$refs.sketch_multiple_file.click()))
                    }, _hoisted_19, 512))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.document.sketch_arr[_ctx.subpage-2]['file']==''?'не загружен':_ctx.document.sketch_arr[_ctx.subpage-2]['file'].split("/")[_ctx.document.sketch_arr[_ctx.subpage-2]['file'].split("/").length-1]), 1),
                  (_ctx.document.sketch_arr[_ctx.subpage-2]['file']!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "downloadSpan",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=fileupload&filename=sketch_multiple_file&element='+(_ctx.subpage-2), _ctx.document.sketch_arr[_ctx.subpage-2]['file'].split('/')[_ctx.document.sketch_arr[_ctx.subpage-2]['file'].split('/').length-1]);})
                      }, "Скачать"))
                    : _createCommentVNode("", true),
                  (_ctx.document.sketch_arr[_ctx.subpage-2]['file']!='')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "delSpan",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitFile('sketch_multiple_file', _ctx.subpage-2, _ctx.document.sketch_arr[_ctx.subpage-2]['name'], '1')))
                      }, [
                        _createVNode(_component_Trash)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.proc_upload)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_21, _hoisted_27))
                  : _createCommentVNode("", true)
              ], 4),
              (_ctx.subpage == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                : _createCommentVNode("", true),
              (_ctx.subpage > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ], 64))
}